import ReactGA from 'react-ga';

export default function setupGoogleAnalytics() {
  const id = process.env.REACT_APP_GOOGLE_ANALYTICS_UNIVERSAL_ID;
  if (id) {
    ReactGA.initialize(id);
  }
}
